import api from '../api';

export const getKraftonNews = () =>
  api({
    headers: {
      'Service-Namespace': 'PUBG_OFFICIAL'
    },
    method: 'get',
    skipDelegateHeader: true, // delegate's header causes a CORS error
    url: `https://api-foc.krafton.com/content/post/news?lang=en&displayLocationType=NORMAL&size=3&page=1`
  });
